import React from 'react';

class ListItemThongKeThanhTraLai extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    let Item = this.props.item || {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{Item.donVi ? Item.donVi.ten : (Item.capDonVi ? Item.capDonVi.ten : '')}</td>
        <td className='txt-center'>{Item.tongSo ? Item.tongSo : 0}</td>
        <td className='txt-center'>{Item.kyTruocChuyenSang ? Item.kyTruocChuyenSang : 0}</td>
        <td className='txt-center'>{Item.trienKhaiTrongKyBaoCao ? Item.trienKhaiTrongKyBaoCao : 0}</td>

        <td className='txt-center'>{Item.ketThucThanhTraTrucTiep ? Item.ketThucThanhTraTrucTiep :0}</td>
        <td className='txt-center'>{Item.daBanHanhKetLuan ? Item.daBanHanhKetLuan : 0}</td>
        <td className='txt-center'>{Item.viPhamTrinhTu ? Item.viPhamTrinhTu : 0}</td>
        <td className='txt-center'>{Item.ketLuanKhongPhuHop ? Item.ketLuanKhongPhuHop : 0}</td>
        <td className='txt-center'>{Item.saiLamApDungPhapLuat ? Item.saiLamApDungPhapLuat : 0}</td>

        <td className='txt-center'>{Item.coYLamSaiLechHoSo ? Item.coYLamSaiLechHoSo : 0}</td>
        <td className='txt-center'>{Item.viPhamNghiemTrong ? Item.viPhamNghiemTrong : 0}</td>
        <td className='txt-center'>{Item.soDonViDaThanhTraLai ? Item.soDonViDaThanhTraLai : 0}</td>
        <td className='txt-center'>{Item.soDonViCoViPham ? Item.soDonViCoViPham : 0}</td>
        <td className='txt-right'>{Item.viPhamVeKinhTeTien ? Item.viPhamVeKinhTeTien : 0}</td>

        <td className='txt-right'>{Item.viPhamVeKinhTeDat ? Item.viPhamVeKinhTeDat :0}</td>
        <td className='txt-right'>{Item.kienNghiThuHoiTien ? Item.kienNghiThuHoiTien : 0}</td>
        <td className='txt-right'>{Item.kienNghiThuHoiDat ? Item.kienNghiThuHoiDat : 0}</td>
        <td className='txt-right'>{Item.kienNghiKhacTien ? Item.kienNghiKhacTien : 0}</td>
        <td className='txt-right'>{Item.kienNghiKhacDat ? Item.kienNghiKhacDat : 0}</td>

        <td className='txt-center'>{Item.hanhChinhToChuc ? Item.hanhChinhToChuc : 0}</td>
        <td className='txt-center'>{Item.hanhChinhCaNhan ? Item.hanhChinhCaNhan : 0}</td>
        <td className='txt-center'>{Item.chuyenCoQuanDieuTraVu ? Item.chuyenCoQuanDieuTraVu : 0}</td>
        <td className='txt-center'>{Item.chuyenCoQuanDieuTraDoiTuong ? Item.chuyenCoQuanDieuTraDoiTuong : 0}</td>
        <td className='txt-right'>{Item.ketQuaThucHienTienDaThu ? Item.ketQuaThucHienTienDaThu : 0}</td>

        <td className='txt-right'>{Item.ketQuaThucHienDatDaThu ? Item.ketQuaThucHienDatDaThu :0}</td>
        <td className='txt-center'>{Item.ketQuaThucHienToChuc ? Item.ketQuaThucHienToChuc :0}</td>
        <td className='txt-center'>{Item.ketQuaThucHienCaNhan ? Item.ketQuaThucHienCaNhan :0}</td>
        <td className='txt-center'>{Item.ketQuaThucHienVu ? Item.ketQuaThucHienVu :0}</td>
        <td className='txt-center'>{Item.ketQuaThucHienDoiTuong ? Item.ketQuaThucHienDoiTuong :0}</td>
        <td className='ghi-chu'>{Item.ghiChu ? Item.ghiChu : ''}</td>
      </tr>
    );
  }
}

export default ListItemThongKeThanhTraLai;



// WEBPACK FOOTER //
// ./src/components/modules/thong-ke-bao-cao/datatable/ListItemThongKeThanhTraLai.jsx